// @flow
import * as React from 'react';
import Icon from '../../Icons/Icon';
import styles from './styles';

const computePercentageValueChanged = (value, oldValue) => {
  if (!value || !oldValue || value > oldValue) {
    return 0;
  }

  return Math.abs(Math.round(100 - (value * 100) / oldValue));
};

type Props = {
  value: number,
  valueFormatted: string,
  oldValue: ?number,
  withRichData: ?boolean,
};

function Price({ value, valueFormatted, oldValue, withRichData }: Props): React.Node {
  const percentage = computePercentageValueChanged(value, oldValue);

  if (!value) {
    return null;
  }

  const longNumberClass = valueFormatted && valueFormatted.length > 15 ? 'longNumber' : '';

  return (
    <div>
      <p
        className={`price ${longNumberClass}`}
        itemScope={withRichData}
        itemProp="priceSpecification"
        itemType="https://schema.org/PriceSpecification"
      >
        <meta itemProp="price" content={value} />
        {valueFormatted}
        {percentage > 0 ? (
          <span className="change">
            <strong>{computePercentageValueChanged(value, oldValue)}%</strong>
            <Icon type="arrow-down" width={14} />
          </span>
        ) : null}
      </p>

      <style jsx>{styles}</style>
    </div>
  );
}

Price.defaultProps = {
  oldValue: null,
  withRichData: false,
};

export default Price;



// WEBPACK FOOTER //
// ./app/components/shared/Labels/Price/index.js